import { useState } from "react";
import { Provider } from "react-redux";
import { JssProvider } from "react-jss";
import { PersistGate } from "redux-persist/integration/react";

import MainContainer from "./containers/main-container";
import FatalErrorMessage from "./components/common/error/fatal-error-message";
import { isMobileDevice } from "./utils/device-helper";
import useThemeStyles from "./utils/theme-utils/useThemeStyles";
import createGenerateId from "./utils/jss-helper";
import SelectTheme from "./components/demo/select-theme";

const generateId = createGenerateId();

const App = (props) => {
  const {
    groceryCrudStore,
    groceryCrudPersistor,
    theme: themeProp,
    loadCssTheme,
    loadCssIcons,
    loadCssThirdParty,
    skin,
    settings,
    configurationSettings,
    publishEvents,
  } = props;

  const [theme, setTheme] = useState(
    themeProp || localStorage.getItem("gc-theme") || "bootstrap-v5"
  );

  useThemeStyles(skin);

  try {
    const MainContainerWithTheme = () => (
      <MainContainer
        isMobileDevice={isMobileDevice()}
        loadCssIcons={loadCssIcons}
        loadCssTheme={loadCssTheme}
        loadCssThirdParty={loadCssThirdParty}
        settings={settings}
        skin={skin}
        theme={theme}
        configurationSettings={configurationSettings}
        publishEvents={publishEvents}
      />
    );

    return (
      <>
          <JssProvider generateId={generateId}>
            <Provider store={groceryCrudStore}>
              {groceryCrudPersistor ? (
                <>
                  <PersistGate loading={null} persistor={groceryCrudPersistor}>
                    <MainContainerWithTheme />
                  </PersistGate>
                </>)
                  : (
                      <MainContainerWithTheme />
                  )
              }
            </Provider>
          </JssProvider>
        { // If theme is defined as prop then we are not offering any dynamic implementation of the theme
          // This is only for the development
          themeProp ? null : (
              <SelectTheme setTheme={setTheme} theme={theme} />
          )
        }
      </>
    );
  } catch (error) {
    console.log(error);
    return <FatalErrorMessage />;
  }
};

export default App;
